// extracted by mini-css-extract-plugin
export default {"countdownWrapper":"Countdown_countdownWrapper__Lt3JL","countdown":"Countdown_countdown__FqiCN","box":"Countdown_box__UdWiC"};